import { useLocalization } from "@tm/localization"
import { useSelector } from "react-redux"
import { Box, Loader, Typography, TyreSizeTable } from "@tm/components"
import { filterTyres } from "@bundles/tyres/components/summary/business"
import { MainState } from "../../../main"
import { mapTyres } from "../../business/helpers"

const Wrapper = ({ children }: { children: React.ReactNode }) => {
    const { translateText } = useLocalization()

    return (
        <Box>
            <Typography variant="h1" marginBottom="0.5em">
                {translateText(726)}
            </Typography>
            {children}
        </Box>
    )
}

const Title = ({ sameSize }: { sameSize?: boolean }) => {
    const { translateText } = useLocalization()
    return (
        <>
            <Typography variant="body1">{translateText(sameSize ? 240 : 13913)}</Typography>
            <Typography variant="body3">{translateText(sameSize ? 13923 : 13924)}</Typography>
        </>
    )
}

export default function RimStandardTyres() {
    const { translateText } = useLocalization()
    const {
        driveRightTyres: { frontTires, rearTires, error, loading },
    } = useSelector((s: MainState) => ({ driveRightTyres: s.wheelsList.base.driveRightTyres }))
    const [sameSizeTyres, mixSizeTyres] = filterTyres(mapTyres(frontTires, rearTires))

    if (loading) {
        return (
            <Wrapper>
                <Loader />
            </Wrapper>
        )
    }

    if (error) {
        return (
            <Wrapper>
                <Typography> {translateText(163)}</Typography>
            </Wrapper>
        )
    }

    return (
        <Wrapper>
            {!!sameSizeTyres.length && <Title sameSize />}
            <TyreSizeTable sameSize tyreList={sameSizeTyres} scrollable={false} viewOnly />
            {!!mixSizeTyres.length && <Title />}
            <TyreSizeTable sameSize={false} tyreList={mixSizeTyres} scrollable={false} viewOnly />
        </Wrapper>
    )
}
